import { defineComponent as _defineComponent } from 'vue'
import Action from "@/components/atoms/action/Action.vue";
import ChevronIcon from "@/icons/ChevronIcon.vue";
import { computed, onMounted, ref, watch } from "vue";

export interface PaginatorProps {
  currentPage: number;
  limit: number;
  totalRows: number;
  onPageChange: (page: number, limit: number) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Paginator',
  props: {
    currentPage: null,
    limit: null,
    totalRows: null,
    onPageChange: null
  },
  setup(__props: any) {

const props = __props as {
  currentPage: number;
  limit: number;
  totalRows: number;
  onPageChange: (page: number, limit: number) => void;
};



const pages = ref<number[]>([]);

const pagesCalculator = () => {
  const totalPages = Math.ceil(props.totalRows / props.limit);
  pages.value = Array.from({ length: totalPages }, (_, i) => i + 1);
};

const handlePageClick = (item: number | string) => {
  if (typeof item !== "number") return;
  changePage(item);
};

const changePage = (page: number) => {
  if (page < 1 || page > pages.value.length) return;
  props.onPageChange(page, props.limit);
};

onMounted(pagesCalculator);

watch(
  () => props.limit,
  pagesCalculator
);

watch(
  () => props.totalRows,
  pagesCalculator
);

const visiblePages = computed(() => {
  const total = pages.value.length;
  const current = props.currentPage;

  if (total <= 5) {
    return pages.value;
  }

  const result: (number | string)[] = [];

  result.push(1);

  let start = Math.max(2, current - 1);
  let end = Math.min(total - 1, current + 1);

  if (start > 2) {
    result.push("...");
  }

  for (let i = start; i <= end; i++) {
    result.push(i);
  }

  if (end < total - 1) {
    result.push("...");
  }

  result.push(total);

  return result;
});

return { __sfc: true,props, pages, pagesCalculator, handlePageClick, changePage, visiblePages, Action, ChevronIcon }
}

})